<template>
  <bg-summary-group>
    <bg-summary
      :value="centsToReal(receivedAmount)"
      variant="success"
      icon="check-price"
      title="Recebidos"
      layout="stacked"
      :loading="loading"
    />
    <bg-summary
      :value="centsToReal(authorizedAmount)"
      :variant="hasCardCharge ? 'success' : 'neutral'"
      :loading="loading"
      icon="calendar_today"
      title="A receber"
      layout="stacked"
      :tooltip="!hasCardCharge ? 'Fale com o suporte e habilite cartão de crédito para impulsionar suas vendas.' : undefined"
    />
    <bg-summary
      :value="centsToReal(pendingAmount)"
      :loading="loading"
      variant="warning"
      icon="clock"
      title="Pendentes"
      layout="stacked"
    />
    <bg-summary
      :value="centsToReal(canceledAmount)"
      :loading="loading"
      variant="neutral"
      icon="cancel"
      title="Cancelados"
      layout="stacked"
    />
    <bg-summary
      :value="centsToReal(unauthorizedAmount)"
      :loading="loading"
      variant="danger"
      icon="error"
      title="Negados"
      layout="stacked"
    />
  </bg-summary-group>
</template>

<script setup>
import { BgSummary, BgSummaryGroup } from '@transfeeradev/bridge';
import settingsResource from '@/apps/payments/resources/settings';
import { centsToReal } from '@/commons/formatters/currency';
import { computed, ref } from 'vue';
import { captureException } from '@sentry/vue';

defineProps({
  receivedAmount: {
    type: Number,
    required: true,
    default: 0
  },
  authorizedAmount: {
    type: Number,
    required: true,
    default: 0
  },
  pendingAmount: {
    type: Number,
    required: true,
    default: 0
  },
  canceledAmount: {
    type: Number,
    required: true,
    default: 0
  },
  unauthorizedAmount: {
    type: Number,
    required: true,
    default: 0
  },
  loading: {
    type: Boolean,
    default: false
  }
});

const settings = ref();

const hasCardCharge = computed(() => settings.value?.hasCardCharge);

const getSettings = async () => {
  try {
    const response = await settingsResource.get();
    settings.value = response;
  } catch (error) {
    captureException(error);
  }
};

getSettings();
</script>
